import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/settings/team")({
  head: () => ({ meta: [{ title: "Team & Roles | Settings" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-settings-team")),
});
